import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Clock, LogOut, Mail } from 'lucide-react';

const PendingApproval = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="pending-approval-page">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 pb-8 text-center space-y-6">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto">
            <Clock className="w-8 h-8 text-amber-600" />
          </div>

          <div className="space-y-2">
            <h1 className="font-serif text-2xl font-bold text-foreground">Account Pending Approval</h1>
            <p className="text-muted-foreground">
              Thank you for registering, <strong>{user?.full_name}</strong>. Your account is awaiting administrator approval.
            </p>
          </div>

          <div className="bg-muted/50 rounded-sm p-4 text-left space-y-2">
            <div className="flex items-center gap-2 text-sm">
              <Mail className="w-4 h-4 text-muted-foreground flex-shrink-0" />
              <span className="text-muted-foreground">Registered as: <strong className="text-foreground">{user?.email}</strong></span>
            </div>
            <p className="text-sm text-muted-foreground">
              You will receive an email notification once your account has been approved. This typically takes 1-2 business days.
            </p>
          </div>

          <Button variant="outline" onClick={logout} className="w-full" data-testid="pending-logout-btn">
            <LogOut className="w-4 h-4 mr-2" />
            Sign Out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default PendingApproval;
